<div class="ng-search-container">
    <div class="ng-search"
         (click)="onFocus()">
        <div class="ng-search-input">
            <label class="ng-search-label"
                   [class.selected]="isHotelSelected"
                   [class.focused]="inFocus">{{ messages.findHotelByName }}</label>
            <input #searchName
                   (focusout)="onFocusOut()"
                   type="text"
                   class="ng-search-name" />
            <button *ngIf="isHotelSelected || searchNameLength !== 0"
                    type="button"
                    class="ng-clear-btn"
                    (click)="onClickClear()"></button>
        </div>
    </div>
    <ul *ngIf="hotels.length"
        class="ng-search-result-container">
        <li class="ng-suggest-hotel"
            *ngFor="let hotel of hotels"
            (click)="onClick(hotel)">
            {{ hotel.name }}
        </li>
    </ul>
</div>
